var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppLayout',{attrs:{"fluid":"","enable-footer":false}},[_c('VContainer',{attrs:{"id":"login-page","fill-height":"","fluid":""}},[_c('VRow',{attrs:{"align-center":""}},[_c('VCol',{attrs:{"cols":"12","offset-md":"2","md":"6","lg":"4"}},[_c('RecoverForm')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }